/**
 * Cine cere Panoul cu bună știință.
 *
 * Ecranul de pornire (Setări → Personalizare) e unde aterizezi după
 * autentificare sau când deschizi aplicația — nu un ocol pentru fiecare
 * drum spre „/". Până la 12.10 era: cu pornirea pe Calendar, linkul „Panou"
 * din meniu și tasta `d` duceau tot în Calendar, deci Panoul nu se mai putea
 * deschide deloc. Linkul și tasta poartă acum semnul ăsta în starea
 * navigării, iar `/` fără el e o aterizare.
 *
 * Stă în starea istoricului, nu în adresă: un reload sau un semn de carte pe
 * „/" e tot o deschidere a aplicației, iar Înapoi la un Panou deschis din
 * meniu îl găsește tot Panou.
 */
export const OPEN_PANOU = { panou: true } as const;

/** Whether `/` should send this person to the calendar instead of the Panou. */
export function landsOnCalendar(input: {
  landingScreen: unknown;
  canSeeCalendar: boolean;
  navigationState: unknown;
}): boolean {
  if (input.landingScreen !== 'calendar' || !input.canSeeCalendar) return false;
  const state = input.navigationState as { panou?: unknown } | null | undefined;
  return state?.panou !== true;
}
